import React, { PropTypes } from "react";
import ComponentRegistry from "Fratello/Common/ComponentRegistry";

import FeedbackController from "../../../../../../../src-js/Fratello/Basket/Controllers/FeedbackController";
import BasketListController from "../../../../../../../src-js/Fratello/Basket/Controllers/BasketListController";
import DiscountsController from "../../../../../../../src-js/Fratello/Basket/Controllers/DiscountsController";
import CouponController from "../../../../../../../src-js/Fratello/Basket/Controllers/CouponController";
import ShippingController from "../../../../../../../src-js/Fratello/Basket/Controllers/ShippingController";

export default function BasketView({
    store,
    value,
    basketItems,
    subtotal,
    shipping,
    discounts,
    coupon,
    vats,
    grandtotal,
    labels
}) {
    const Summary = ComponentRegistry.get("BasketAtomsSummary");
    const Vats = ComponentRegistry.get("BasketAtomsVats");

    return (
      <div className="basket clearfix">
        <FeedbackController {...value.feedback} view="BasketViewsFeedbackView" />

          <div className="basket-header hidden-md-down">
              <div className="row">
                  <div className="col-lg-2"></div>
                  <div className="col-lg-2">{labels.ref}</div>
                  <div className="col-lg-3">{labels.article_name}</div>
                  <div className="col-lg-1">{labels.price_unit}</div>
                  <div className="col-lg-2"></div>
                  <div className="col-lg-1">{labels.subtotal}</div>
                  <div className="col-lg-1 text-right">{labels.stock}</div>
              </div>
          </div>

        <BasketListController
          {...basketItems}
          items={value.items}
          store={store}
          view="BasketViewsBasketListView"
          itemView="BasketViewsBasketItemView"
        />

        {/*<Summary {...subtotal} value={value.pricing.basketTotal} requiresVat />*/}
        {/*<ShippingController*/}
          {/*{...shipping}*/}
          {/*value={value.shipping}*/}
          {/*pricing={value.pricing.shippingTotal}*/}
          {/*store={store}*/}
          {/*view="BasketViewsShippingView"*/}
        {/*/>*/}
        <DiscountsController
          {...discounts}
          items={value.discounts}
          store={store}
          view="BasketViewsDiscountListView"
          itemView="BasketViewsDiscountView"
        />
        {/*<CouponController*/}
            {/*{...coupon}*/}
            {/*store={store}*/}
            {/*view="BasketViewsCouponView"*/}
        {/*/>*/}
        {/*<Vats {...vats} value={value.pricing.vatTotals} />*/}
        <Summary {...grandtotal} value={value.pricing.grandTotal} requiresVat />
      </div>
    );
}

BasketView.propTypes = {
    labels: PropTypes.shape({}),
    store: PropTypes.string,
    basketItems: PropTypes.shape({}),
    shipping: PropTypes.shape({}),
    coupon: PropTypes.shape({}),
    discounts: PropTypes.shape({}),
    subtotal: PropTypes.shape({}),
    grandtotal: PropTypes.shape({}),
    vats: PropTypes.shape({}),
    value: PropTypes.shape({
        items: PropTypes.arrayOf(PropTypes.shape({})),
        discounts: PropTypes.arrayOf(PropTypes.shape({})),
        feedback: PropTypes.shape({}),
        shipping: PropTypes.shape({}),
        pricing: PropTypes.shape({
            basketTotal: PropTypes.string,
            shippingTotal: PropTypes.string,
            vatTotals: PropTypes.shape({}),
            grandTotal: PropTypes.string,
        }),
    }),
};



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/Basket/Views/BasketView.jsx